<i
  class='check-icon animated zoomIn'
  nz-icon
  nzType='check-circle'
  nzTheme='fill'
  style='color: #52c41a'></i>
